import { render, staticRenderFns } from "./IconStarOutline.vue?vue&type=template&id=75e57faa"
import script from "./IconStarOutline.vue?vue&type=script&lang=js"
export * from "./IconStarOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports